import { render } from "./VoterList.vue?vue&type=template&id=1d2abf3a&scoped=true"
import script from "./VoterList.vue?vue&type=script&lang=ts"
export * from "./VoterList.vue?vue&type=script&lang=ts"

import "./VoterList.vue?vue&type=style&index=0&id=1d2abf3a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d2abf3a"

export default script